import {
  createListCollection,
  Select,
  SelectItem,
} from "shared/components/Spor";
import { useTranslation } from "react-i18next";
import { log, LogLevel } from "logging/datadogBrowserLogs";
import { useCallback, useMemo } from "react";

export const LanguageSwitch = () => {
  const { t, i18n } = useTranslation();

  const languages = useMemo(
    () =>
      createListCollection({
        items: [
          {
            value: "no",
            label: t("Norsk", { lng: "no" }),
          },
          {
            value: "se",
            label: t("Svensk", { lng: "se" }),
          },
        ],
      }),
    [t],
  );

  const changeLanguage = useCallback(
    (lng: string) => {
      i18n.changeLanguage(lng).catch((error: Error) => {
        log(
          LogLevel.error,
          "LanguageSwitch",
          `Could not switch language. Error: ${error.message} `,
        );
      });
      localStorage.setItem("Language", lng);
    },
    [i18n],
  );

  return (
    <Select
      collection={languages}
      label={t("Språk")}
      value={[i18n.language]}
      onValueChange={(item) => changeLanguage(item.value[0] ?? "no")}
    >
      {languages.items.map((lang) => (
        <SelectItem key={lang.value} item={lang}>
          {lang.label}
        </SelectItem>
      ))}
    </Select>
  );
};
